import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import BuyerOnlyRouteMixin from 'sh-www/mixins/buyer-only-route-mixin';
import { ASSIGNMENT } from 'sh-www/models/assignment';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class PostingEditRoute extends Route.extend(BuyerOnlyRouteMixin) {
  /**
   * Register services
   */
  @service router;
  @service('states/routes/posting-create') state;
  @service('state-managers/routes/posting-create') stateManager;

  /**
   * @inheritDoc
   */
  activate(transition) {
    super.activate(...arguments);

    this.stateManager.toggleConfirmDiscardData(true);
    this.state.initializeForcedProperties();
    trackPageViewFromTransition(this, transition, '/posting/:id/edit/');
  }

  /**
   * @inheritDoc
   */
  deactivate() {
    super.deactivate(...arguments);

    const applicationController = this.controllerFor('application');
    applicationController.set('isShowCreatePostingHeader', false);

    this.stateManager.initStateManager();
    this.stateManager.toggleConfirmDiscardData(false);
  }

  /** @inheritDoc */
  beforeModel() {
    this.intermediateTransitionTo('loading');
  }

  /**
   * @inheritDoc
   */
  model() {
    this.stateManager.setPostingType(ASSIGNMENT.TYPES.STANDARD);

    const { assignId } = this.paramsFor('posting');

    // load these first so they can be used within assignment state
    const classifications = this.stateManager.loadClassifications();
    const countries = this.stateManager.loadCountries();
    const regions = this.stateManager.loadRegions();
    const services = this.stateManager.loadServices();

    return Promise.all([
      classifications,
      countries,
      regions,
      services,
    ])
      .then(() => this.stateManager.loadAssignment(assignId, true))
      .then((assignment) => {
        const companyMemberships = this.stateManager.loadCompanyWithMembers(assignment.buyer.company.id);
        const companyTeams = this.stateManager.loadCompanyTeams(assignment.buyer.company.id);

        return Promise.all([companyMemberships, companyTeams]);
      })
      .catch(() => {
        // error - just go to 404 page. already logged.
        this.router.transitionTo(EMBER_ROUTE_NAMES.PAGE_NOT_FOUND);
      });
  }

  /**
   * @inheritDoc
   */
  setupController() {
    super.setupController(...arguments);

    const applicationController = this.controllerFor('application');
    applicationController.set('isShowCreatePostingHeader', true);
  }

  /**
   * @inheritDoc
   */
  _redirectUnauthorizedUser() {
    const { assignId } = this.paramsFor('posting');
    this.router.transitionTo('posting', assignId);
  }

  /**
   * @inheritDoc
   */
  _isAllowAdmins() {
    return true;
  }
}

export default PostingEditRoute;
